import script from "./Article36.vue?vue&type=script&setup=true&lang=js"
export * from "./Article36.vue?vue&type=script&setup=true&lang=js"

import "./Article36.vue?vue&type=style&index=0&id=0db87708&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db87708"]])

export default __exports__